/*
table
*/
/**
* TABLES
* view more functionnality for SIMPLE TABLE MODULE
*/
// get viewmore links
var viewmore_links = $(".view-more-table");


// go through them and hide them if table counts less than 4 rows
viewmore_links.each(function() {
  var module_el = $(this).parents("[data-type=module]");
  var rows = module_el.find(".row-anchor");
  var number_displayed = 0;

  // get the number of rows displayed by default (choosen inside the LESS file)
  rows.each(function() {
    if ($(this).is(":visible")) {
      number_displayed += 1;
    }
  });

  // set attribute for number displayed
  $(this).attr("data-number", number_displayed);

  // hide the view more link if not necessary
  if (rows.length <= number_displayed) {
    $(this).hide();
  }
});

// click event handling
viewmore_links.click(function () {
  var module_el = $(this).parents("[data-type=module]");
  var number_to_add = $(this).attr("data-number");
  var rows = module_el.find(".row-anchor").not(":visible");
  var rows_number = rows.length;
  if (rows_number > number_to_add) {
    for (var i = 0; i < number_to_add; i++) {
      rows.eq(i).toggleClass("visible");
    }
  }
  else {
    rows.toggleClass("visible");
    $(this).hide();
  }
});





// MOBILE TABLE DROPDOWN EVENT HANDLER
$(document.body).on("click", ".table-dropdown-trigger", function () {
  // get module
  var module_el = $(this).parents("[data-type=module]");

  // main dropdown management
  if ($(this).hasClass("main-dropdown")) {
    // clear all open class in the module
    module_el.find(".table-dropdown-trigger.main-dropdown").not($(this)).removeClass("open");
    module_el.find(".table-dropdown-trigger.main-dropdown").not($(this)).next(".dropdown_content").removeClass("open");
  }
  // sub dropdown management
  else if ($(this).hasClass("sub-dropdown")) {
    // clear all open class in the module
    module_el.find(".table-dropdown-trigger.sub-dropdown").not($(this)).removeClass("open");
    module_el.find(".table-dropdown-trigger.sub-dropdown").not($(this)).next(".dropdown_content").removeClass("open");
  }

  // toggle OPEN class
  $(this).toggleClass("open");
  $(this).siblings(".dropdown_content").toggleClass("open");
});
$(document.body).on("click", ".main-dropdown", function () {

  if($(this).parents('.custom_dropdown').hasClass('opened')){
    $('.custom_dropdown').removeClass('opened');
  } else {
    $('.custom_dropdown').removeClass('opened');
    $(this).parents('.custom_dropdown').addClass('opened');
  }

});


// DESKTOP TABLE DROPDOWN EVENT HANDLER
$(document.body).on("click", ".table_row.parent", function () {
  var index_click = $(this).index();

  $('.table_row.parent').each(function () {
    var index_each = $(this).index();

    // Change state of current open element
    // if it isn't the one clicked
    if (index_click != index_each) {
      $(this).removeClass('open');
      $(this).next('.child').removeClass('open');
    }

  });

  //Change state of clicked element
  $(this).toggleClass('open');
  $(this).next('.child').toggleClass('open');
});










/**
* TABLES
* Hide TABLE if empty content
*/
//-- for dekstop tables
var table_list = ["desk_simple_table", "desk_big_drop_table", "desk_drop_table"];



//-- go through desktop tables
table_list.forEach(function(t) {

  //-- go though every table's module with the same "t" class
  $("[class^="+t+"]").each(function() {
    var _module = $(this);

    //-- get its class
    var _class = $.grep(this.className.split(" "), function(v, i){
      return v.indexOf(t) === 0;
    }).join();

    //-- get table and its rows
    var table = _module.find(".table");
    var rows = table.find(".table_row");

    //-- if table is empty, hide it and hide related components
    if (typeof rows === "undefined" || rows.length < 1) {
      _module.remove();
      $("[data-nocontent="+_class+"]").hide();
    }
  });
});



//-- SEPARATOR CONTROL

  //---- for mobile tables
  var table_list = ["mob_drop_table", "mob_big_drop_table", "mob_simple_table"];

  //-- go through mobile tables
  table_list.forEach(function(t) {

    //-- go though every table's module with the same "t" class
    $("[class^="+t+"]").each(function() {
      var _module = $(this);

      //-- get its class
      var _class = $.grep(this.className.split(" "), function(v, i){
          return v.indexOf(t) === 0;
      }).join();

      //-- get table and its rows
      var table_drop = _module.find(".custom_dropdown");
      var rows_drop = table_drop.find(".dropdown_row");

      var table_simple = _module.find(".simple-table");
      var rows_simple = table_simple.find(".table_row");

      //-- if table is empty, hide it and hide related components
      if ((typeof rows_drop === "undefined" || rows_drop.length < 1) && (typeof rows_simple === "undefined" || rows_simple.length < 1)) {

        //-- delete previous separator FOR CBP ONLY
        if (PAGE_CODE === "cbp") {
          _module.prevAll(".mob_separator-1:first").remove();
        }

        //-- delete module
        _module.hide();
        //-- delete related content
        $("[data-nocontent="+_class+"]").hide();
      }
    });
  });
